// Canonical document-processing status vocabulary — distinct from jobStatus.js's
// pending/running/done/failed (see that file's header comment). Document uploads
// (document_processing_status) use pending | processing | completed | failed.

export const DOCUMENT_PROCESSING_STATUSES = new Set(["pending", "processing"]);
export const DOCUMENT_FAILURE_STATUSES = new Set(["failed"]);
export const DOCUMENT_DONE_STATUSES = new Set(["completed"]);

/** True while the document is still being ingested (queued or processing). */
export const isDocumentProcessingStatus = (status) =>
  DOCUMENT_PROCESSING_STATUSES.has(status);

/** True when document processing ended in failure. */
export const isDocumentFailureStatus = (status) =>
  DOCUMENT_FAILURE_STATUSES.has(status);

/** True when document processing finished successfully. */
export const isDocumentDoneStatus = (status) =>
  DOCUMENT_DONE_STATUSES.has(status);

/** True when the document has reached any terminal state (success or failure). */
export const isDocumentTerminalStatus = (status) =>
  isDocumentDoneStatus(status) || isDocumentFailureStatus(status);
